import { useDispatchRequest, useQuery } from '@redux-requests/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useConnect } from '../../../../common/hooks/useConnect';
import { useInitEffect } from '../../../../common/hooks/useInitEffect';
import {
  Provider,
  SupportedBlockchainNetworkId,
} from '../../../../common/types';
import { t } from '../../../../common/utils/intl';
import { QueryError } from '../../../../components/QueryError/QueryError';
import { UserActionTypes } from '../../../../store/actions/UserActions';
import { IUserInfo } from '../../../../store/apiMappers/userApi';
import { IStoreState } from '../../../../store/reducers';
import { AvalancheActions } from '../../../stake-avax/actions/AvalancheActions';
import { fetchStats as fetchPolygonStats } from '../../../stake-polygon/actions/fetchStats';
import { binance as binanceLogo } from '../assets/assets';
import { PROVIDERS } from '../const';
import { WalletBalance } from '../WalletBalance/WalletBalance';
import { HeaderComponent } from './HeaderComponent';

export const Header = () => {
  const dispatchRequest = useDispatchRequest();
  const { dispatchDisconnect } = useConnect();

  const { isConnected: isAuth, chainId } = useSelector(
    (state: IStoreState) => state.user,
  );

  useInitEffect(() => {
    dispatchRequest(AvalancheActions.fetchClaimStats());
    dispatchRequest(fetchPolygonStats());
  });

  const isSupportedNetwork =
    chainId !== undefined
      ? SupportedBlockchainNetworkId.includes(chainId)
      : false;

  const { data, error } = useQuery<IUserInfo | null>({
    type: UserActionTypes.FETCH_ACCOUNT_DATA,
  });

  const isBinance = data?.walletType === Provider.binance;
  const binanceCaption = t(PROVIDERS[Provider.binance].caption);
  const walletIcon = isBinance ? binanceLogo : data?.walletIcon;
  const walletName = isBinance ? binanceCaption : data?.walletName;

  const authorized = (
    <HeaderComponent
      isAuth={isSupportedNetwork && isAuth}
      walletAddress={data?.address}
      blockchainType={data?.blockchainType}
      walletName={walletName}
      walletIcon={walletIcon}
      walletType={data?.walletType}
      balanceSlot={<WalletBalance />}
      onDisconnectClick={dispatchDisconnect}
    />
  );

  const notAuthorized = <HeaderComponent isAuth={false} />;

  if (error && isSupportedNetwork) {
    return <QueryError error={error} />;
  }

  return isAuth ? authorized : notAuthorized;
};
